import { Component, input, output } from '@angular/core';
import { MatDialogActions } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { SharedModule } from '../../../shared/shared.module';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { DotsLoaderComponent } from '../../../shared/components/dots-loader/dots-loader.component';
import { AnchorDirective } from '../../../shared/directives/anchor.directive';

@Component({
  selector: 'gnx-dialog-footer',
  imports: [MatDialogActions, MatTooltip, SharedModule, ButtonComponent, DotsLoaderComponent, AnchorDirective],
  templateUrl: './dialog-footer.component.html',
  styleUrl: './dialog-footer.component.scss',
})
export class DialogFooterComponent {
  readonly cancelLabel = input<string>(undefined);
  readonly saveLabel = input<string>(undefined);
  readonly saveDisabled = input<boolean>(undefined);
  readonly saveLoading = input<boolean>(undefined);
  readonly saveTooltip = input<string>(undefined);
  readonly cancel = output<void>();
  readonly save = output<void>();
}
